// TypeScript declaration for HubSpot Conversations API
declare global {
  interface Window {
    HubSpotConversations?: {
      widget: {
        open: () => void;
        close: () => void;
        load: () => void;
      };
    };
  }
}

const Footer = () => {
  const handleLiveChatClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.open();
    } else {
      console.warn("HubSpot chat widget is not loaded yet");
    }
  };

  return (
    <footer className="layout-footer">
      {/* Copyright Section */}
      <div className="footer-copyright">
        <span className="text-gray-500 text-xs">
          © {new Date().getFullYear()} Real Estate Investar. All rights reserved.
        </span>
        <a
          className="text-gray-500 text-xs"
          href="https://info.realestateinvestar.com.au/terms-conditions-v6"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms & Conditions
        </a>
      </div>
    </footer>
  );
};

export default Footer;
